exports.getProcessedCss = function getProcessedCss(styles, options) {
    return '';
};
exports.getStaticCss = function getStaticCss() {
    return '';
};
//# sourceMappingURL=fakeMain.js.map